import { ENABLE_STAGING_SETTING } from '@src/constants';
export default function (request, reject, rootAddress) {
  var service = {};

  service.area = '';
  service.getArea = function () {
    if (service.area) {
      return service.area;
    }
    return request.post('//pl-api.amazingseasun.com/webapp/official/proxy?uri=seasun/ext/getIpArea').then(data => {
      service.area = data.data.areacode;
      return data.data.areacode;
    })
  }


  /**
    获得基本信息
    请求方法: GET, POST
    请求示例: http://<domain>/webapp/mbsubscribe231101/get_config
    */
  service.gwConfig = function () {
    const params = {};
    // 是否开启灰度环境配置
    if (ENABLE_STAGING_SETTING) {
      params.is_huidu = 'huidu_test';
    }
    return request.post(rootAddress + '/webapp/mbsubscribe231101/gw_config', params).then(response => {
      if (response.data.status === 1 /* 成功 */) {
        return response.data.data;
      }
      return reject(response.data);
    });
  };
  /**
    发送邮件验证码
    请求方法: GET, POST
    请求示例: http://<domain>/webapp/mbsubscribe231101/get_email_code?email=495794424@qq.com&lang=cht
    */
  service.getEmailCode = function (params) {
    return request
      .post(rootAddress + '/webapp/mbsubscribe231101/get_email_code', {
        ...params
        // email: email /*  邮箱 */
      })
      .then(response => {
        if (response.data.status === 1 /* 成功 */) {
          /**
           {
          "data{}": []
        }
           */
          return response.data.data;
        }
        return reject(response.data);
      });
  };
  /**
    官网预约
    请求方法: GET, POST
    请求示例: http://<domain>/webapp/mbsubscribe231101/subscribe?email=495794424@qq.com&code=456123
    */
  service.subscribeByGw = function (params) {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/subscribe_by_gw', {
      code: params.code /*  邮箱验证码 */,
      email: params.email /*  邮箱 */,
      utm_source: params.utm_source /* 渠道来源 */,
      subscribe_duration_time: params.subscribe_duration_time // 预约经历时间
    }).then((response) => {
      if (response.data.status === 1 /* 成功 */) {
        /**
            {
              "data{}": []
            }
            */
        return response.data.data;
      }
      return reject(response.data);
    });
  };

  /**
   * 获得预约福利码
   * @returns 
   */
  service.getCodeInSubscribe = function () {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/get_code_in_subscribe', {}).then((response) => {
      if (response.data.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "code": "福利码"
          }
        }
            */
        return response.data.data;
      }
      return reject(response.data);
    });
  };

  /**
   * 获得下载阶段福利码
   * @returns 
   */
  service.getCodeInDownLoad = function () {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/get_code_in_down_load', {}).then((response) => {
      if (response.data.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "code": "福利码"
          }
        }
            */
        return response.data.data;
      }
      return reject(response.data);
    });
  };

  /**
   * 退出
   * @returns 
   */
  service.logout = function () {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/logout', {}).then((response) => {
      if (response.data.status === 1 /* 成功 */) {
        /**
          退出
          */
        return response.data.data;
      }
      return reject(response.data);
    });
  };



  //  礼包接口
  // service.getGiftPackConfig = function () {
  //   return request.post(rootAddress + '/mechabreak/purchase250122/get_config', {}).then(response => {
  //     if (response.data.status === 1 /* 成功 */) {
  //       /**
  //        {
  //        "data{}": {
  //        "reply": "返回字段说明"
  //        },
  //        "data{}.reply{}": {
  //        "is_reserve": "是否预约 0:未预约 1:已预约",
  //        "reserve_count": "预约人数",
  //        "limited_edition_purchase_range_time": "限量礼包抢购时间范围",
  //        "time_limited_purchase_range_time": "限时礼包购买时间范围",
  //        "varify_status": "验证状态 0:未验证 1:已验证",
  //        "bind_email": "绑定邮箱"
  //        }
  //        }
  //        */
  //       return response.data.data;
  //     }
  //     return reject(response.data);
  //   });
  // };
  return service;
}
